module.exports = __webpack_public_path__ + "static/media/source-sans-pro-regular.e7acc589.woff";